import { TFunction } from "i18next";
import { useForm } from "react-hook-form";

import { InputText, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

import { AssetType } from "@type/inventory/asset";
import { BrandType } from "@type/inventory/brand";
import { GroupType } from "@type/inventory/group";
import { SetStateAction } from "react";
import { IconTrash01 } from "@pentabd/icons";

type Input = {
  [key: string]: number;
};

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  handleRequestedAmount: any,
  setIsConfirmationModalOpen: (value: SetStateAction<boolean>) => void,
  setItemId: (value: SetStateAction<number | undefined>) => void,
) => {
  const { language } = useLanguage();

  const { register, setValue } = useForm<Input>();

  return [
    {
      id: 1,
      key: "categoryName",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TABLE.COLUMN.CATEGORY",
      ),
      render: (_: string, row: AssetType) => {
        return <Text color="subtitle1">{row.group.category.name}</Text>;
      },
    },
    {
      id: 2,
      key: "group",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TABLE.COLUMN.GROUP",
      ),
      render: (group: GroupType) => {
        return <Text color="subtitle1">{group.name}</Text>;
      },
    },
    {
      id: 3,
      key: "nameEn",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TABLE.COLUMN.NAME",
      ),
      render: (_: string, row: AssetType) => {
        let name = language === "bn" ? row.nameBn : row.nameEn;
        return <Text color="subtitle1">{name}</Text>;
      },
    },
    {
      id: 4,
      key: "brand",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TABLE.COLUMN.BRAND",
      ),
      render: (brand: BrandType) => {
        return <Text color="subtitle1">{brand.name}</Text>;
      },
    },
    {
      id: 5,
      key: "type",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TABLE.COLUMN.TYPE",
      ),
      render: (type: string) => {
        return <Text color="subtitle1">{type}</Text>;
      },
    },
    {
      id: 6,
      key: "requested_amount",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_CREATE.SELECTED_PRODUCT_TABLE.COLUMN.REQUESTED_AMOUNT",
      ),
      render: (_: any, row: any) => {
        return (
          <InputText
            {...register(`requested_amount_${row.id}`, {
              required: "Amount is required",
              min: 0,
            })}
            onChange={(e) => {
              if (Number(e.target.value) > 0) {
                setValue(`requested_amount_${row.id}`, Number(e.target.value));
                handleRequestedAmount(row.id, e.target.value);
              } else {
                setValue(`requested_amount_${row.id}`, 0);
                handleRequestedAmount(row.id, e.target.value);
              }
            }}
            defaultValue="0"
            size="sm"
            placeholder="Enter request amount"
            type="number"
            controlling
          />
        );
      },
    },
    {
      id: 7,
      key: "id",
      name: "",
      render: (id: number) => {
        return (
          <div
            onClick={() => {
              setIsConfirmationModalOpen(true);
              setItemId(id);
            }}
            className="cursor-pointer"
          >
            <IconTrash01 size={24} fill="danger" />
          </div>
        );
      },
    },
  ];
};
